import { ArrowRightLeft } from 'lucide-react';
import { useBrand } from '../contexts/BrandContext';
import { switchBrandUrl } from '../lib/brand';
import { Badge } from '../components/ui';

/**
 * Header badge naming the brand this console acts as, in that brand's colour,
 * plus a link to the same page on each other brand console the admin may use
 * (multi-tenant merge M3d). Switching is a hostname change, never an in-tab
 * toggle, so two tabs can sit on two brands without confusion.
 */
export function BrandBadge() {
  const { brand, brands } = useBrand();
  const others = brands
    .filter((b) => b.brandKey !== brand.brandKey)
    .map((b) => ({ brand: b, href: switchBrandUrl(window.location, brand, b) }))
    .filter((o): o is { brand: typeof brand; href: string } => o.href !== null);

  return (
    <div className="flex items-center gap-2" data-testid="brand-badge">
      <Badge variant="outline" className="gap-1.5 border-current/30 font-semibold" style={{ color: brand.primaryColour ?? undefined }}>
        <span
          className="inline-block h-2 w-2 rounded-full"
          style={{ backgroundColor: brand.primaryColour ?? 'currentColor' }}
          aria-hidden
        />
        {brand.name}
      </Badge>
      {others.map(({ brand: other, href }) => (
        <a
          key={other.brandKey}
          href={href}
          className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
          title={`Open this page on the ${other.name} console`}
        >
          <ArrowRightLeft className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">{other.name}</span>
        </a>
      ))}
    </div>
  );
}
